import React, { useState } from 'react';
import { NCZIElectronicPrescriptionItem } from '../../../Interfaces/ncziElectronicPrescriptionItem';
import LinkButton from '../../../../../Components/Button/LinkButton';
import { Theme } from '../../../../../Enums/Theme.enum';
import NZCIListItem from '../../Base/NZCIListItem';
import FormattedDate from '../../../../../Components/FormattedDate';

//@ts-ignore
import styles from './ElectronicPrescriptionListItem.module.scss';
import ElectronicPrescriptionDetailModal from '../Detail/ElectronicPrescriptionDetailModal';

interface Props {
	item: NCZIElectronicPrescriptionItem;
	onClose: (needReload: boolean) => void;
}

const ElectronicPrescriptionListItem: React.FC<Props> = props => {
	const { item, onClose } = props;

	const [itemOpened, setItemOpened] = useState<boolean>(false);

	const handleClose = (needReload = false) => {
		setItemOpened(false);
		onClose?.(needReload);
	};

	return (
		<div className={styles.wrapper}>
			<div className={styles.border}>
				<div className={styles.content}>
					<div className={styles.header}>
						<div className={styles.openEntryName}>{item.CiarovyKod}</div>
					</div>

					<div className={styles.itemInfo}>
						<NZCIListItem
							title='nczi.createdAt'
							value={<FormattedDate date={item.Datum2Vykazany} />}
						/>
						<NZCIListItem
							title='nczi.electronicPrescription.list.validTo'
							value={<FormattedDate date={item.PlatnostReceptu} />}
						/>
						{item.DiagnozaVykazana && (
							<NZCIListItem
								title='nczi.electronicPrescription.detail.diagnosisCode'
								value={
									item.KodDiagnozaVykazana +
									': ' +
									item.DiagnozaVykazana.displayName
								}
							/>
						)}
						{item.UdajeProdukt.ProduktPZSVykaz && (
							<NZCIListItem
								title='nczi.electronicPrescription.detail.productCode'
								value={
									<>
										{item.PocetOpakovaniOpakovanehoReceptu && (
											<strong>{item.PocetOpakovaniOpakovanehoReceptu}x </strong>
										)}
										{item.UdajeProdukt.ProduktPZSVykaz.code}:{' '}
										<strong>{item.UdajeProdukt.ProduktPZSVykaz.name}</strong>{' '}
										{item.UdajeProdukt.ProduktPZSVykaz.additionalName && (
											<>({item.UdajeProdukt.ProduktPZSVykaz.additionalName})</>
										)}
									</>
								}
							/>
						)}
					</div>
				</div>
				<div className={styles.controls}>
					<LinkButton
						title={'nczi.showDetails'}
						theme={Theme.BLUE}
						onClick={() => setItemOpened(true)}
					/>
				</div>
			</div>
			<ElectronicPrescriptionDetailModal
				opened={itemOpened}
				onClose={handleClose}
				item={item}
			/>
		</div>
	);
};

export default ElectronicPrescriptionListItem;
